export enum StandardType {
  Unspecified = 0,
  CSA = 1,
  UL = 2,
  Both = 3,
}
